export default __webpack_public_path__ + "static/media/icn-brakesign.00ab778b.svg";